






















































































































































































































import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import { UserInfoComponentResourceModel } from '@/modules/user/models/user-resource.model'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import { mixins } from 'vue-class-component'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import { isArray } from '@/modules/shared/helpers/utils/utils'

@Component(
  {
    inheritAttrs: false,
    components: {
      TextEllipsis,
      BaseButton,
      DateTooltipped
    }
  })
export default class AdminUserInfoDialog extends mixins<DialogMixin>(DialogMixin) {

  @Prop({ default: null }) user!: UserInfoComponentResourceModel
  private vipGroup = (isArray(this.user.vip_group)) ? this.user.vip_group : [this.user.vip_group]


  getIcon(verifyType) {
    return this.user.verify[verifyType] ? 'ion checkmark-circle' : 'ion close-circle'
  }

  getColor(verifyType) {
    return this.user.verify[verifyType] ? 'green' : 'red'
  }

}
